// extracted by mini-css-extract-plugin
export default {"homeDivWrapper":"artist_homeDivWrapper__aD7vF","homeContainer":"artist_homeContainer__aYVp1","artistLatestReleaseInfomationDiv":"artist_artistLatestReleaseInfomationDiv__UDAoj"};